const bucketUrl = 'https://storage.googleapis.com/bitte-public';

export const networkFallbackIcons: Record<string, string> = {
  '1': `${bucketUrl}/eth.png`,
  '10': `${bucketUrl}/optimism.png`,
  '56': `${bucketUrl}/bsc.png`,
  '100': `${bucketUrl}/gnosis.png`,
  '137': `${bucketUrl}/polygon.png`,
  '8453': `${bucketUrl}/base.png`,
  '42161': `${bucketUrl}/arbitrum.png`,
  '43114': `${bucketUrl}/avalanche.png`,
  '84532': `${bucketUrl}/base.png`,
  '130': `${bucketUrl}/unichain.webp`,
  '146': `${bucketUrl}/sonic.webp`,
  '1868': `${bucketUrl}/soneium.webp`,
  '80094': `${bucketUrl}/berachain.webp`,
  Ethereum: `${bucketUrl}/eth.png`,
  Optimism: `${bucketUrl}/optimism.png`,
  BSC: `${bucketUrl}/bsc.png`,
  Gnosis: `${bucketUrl}/gnosis.png`,
  Polygon: `${bucketUrl}/polygon.png`,
  Base: `${bucketUrl}/base.png`,
  Arbitrum: `${bucketUrl}/arbitrum.png`,
  'Arbitrum One': `${bucketUrl}/arbitrum.png`,
  Avalanche: `${bucketUrl}/avalanche.png`,
  'Base Sepolia': `${bucketUrl}/base.png`,
  Unichain: `${bucketUrl}/unichain.webp`,
  Sonic: `${bucketUrl}/sonic.webp`,
  Soneium: `${bucketUrl}/soneium.webp`,
  Berachain: `${bucketUrl}/berachain.webp`,
};

export const networkFallbackNames: { [key: string]: string } = {
  '1': 'Ethereum Mainnet',
  '10': 'Optimism',
  '56': 'Binance Smart Chain',
  '100': 'Gnosis Chain',
  '137': 'Polygon',
  '8453': 'Base',
  '34443': 'Mode',
  '42161': 'Arbitrum One',
  '43114': 'Avalanche',
  '84532': 'Base Sepolia',
  '130': 'Unichain',
  '146': 'Sonic',
  '1868': 'Soneium',
  '80094': 'Berachain',
};
